export const itemTypes = [
  {value: 'post', label: 'Posts'},
  {value: 'hotelInfosService', label: 'Serviços'},
  {value: 'hotelInfo', label: 'Informações do Hotel'},
  {value: 'sessionHotelClassification', label: 'Classificações de Sessão'},
  {value: 'hotelPostPages', label: 'Páginas'},
  {value: 'classificationPost', label: 'Posts de Classificação'},
  {value: 'roomService', label: 'Room Service'},
  {value: 'hotelExperience', label: 'Experiências'},
  {value: 'hotelTour', label: 'Tours'},
  {value: 'cleanSafe', label: 'Clean Safe'},
  {value: 'storesHotel', label: 'Lojas do Hotel'},
  {value: 'serviceClassifications', label: 'Classificações de Serviço'},
  {value: 'hotelSchedules', label: 'Horários'},
  {value: 'publicityHotel', label: 'Publicidade'},
  {value: 'hotelActivity', label: 'Atividades'},
  {value: 'gridHotel', label: 'Grade do Hotel'},
  {value: 'hotelServices', label: 'Serviços do Hotel'},
  {value: 'tourIncludes', label: 'Inclusões do Tour'},
]
